import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import Header from 'header';
import Sidebar from 'components/sidebar';
import AdministrationMain from './main';
import ReviewDetail from './reviews/detail';
import Footer from 'components/footer';
import Spinner from 'spinner';
import RatingWrapper from './rating/rating-wraper';
import RatingDetail from './rating/detail';
import StaffReviews from './reviews/staff-reviews';
import InstitutionReviews from './reviews/institution-reviews';
import {Content, ContentInner} from 'components/content'
import {routes} from './routes';

import {loadUser} from 'redux/actions/auth';

const mapStateToProps = state => ({
  user: state.auth.get('user')
});

const mapDispatchToProps = dispatch => ({
  loadUser: () => dispatch(loadUser())
});

class Administration extends Component {

  componentDidMount() {
    this.props.loadUser()
  }

  render() {

    if (this.props.user === undefined) {
      return <Spinner/>;
    }

    return (
      <div>
        <div>
          <Header/>
          <Content>
            <Sidebar routes={routes} cabinet="Кабінет адміністрації"/>
            <ContentInner>
              <Switch>
                <Route exact path="/administration" component={AdministrationMain} />
                <Route exact path="/administration/staff-reviews" component={StaffReviews} />
                <Route exact path="/administration/institution-reviews" component={InstitutionReviews} />
                <Route exact path="/administration/institution-reviews/:page" component={InstitutionReviews} />
                <Route exact path="/administration/staff-reviews/:page" component={StaffReviews} />
                <Route exact path="/administration/staff-reviews/detail/:review_id" component={ReviewDetail} />
                <Route exact path="/administration/rating/" component={RatingWrapper} />
                <Route exact path="/administration/rating/:page" component={RatingWrapper} />
                <Route exact path="/administration/rating/detail/:rating_id" component={RatingDetail} />
              </Switch>
            </ContentInner>
          </Content>
          <Footer />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Administration);



// WEBPACK FOOTER //
// ./src/administration/index.js